module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "affirm"
  }, [_c('div', {
    staticClass: "grade"
  }, [_c('div', {
    staticClass: "grade-text"
  }, [_vm._v("您的评价会让司机做的更好")]), _vm._v(" "), _c('div', {
    staticClass: "grade-star"
  }, [_c('xk-star', {
    attrs: {
      "defScore": 5,
      "isShow": _vm.isShow,
      "disabled": _vm.disabled
    },
    on: {
      "clickChange": _vm.starFn
    }
  })], 1), _vm._v(" "), (_vm.status !== 40 || _vm.remark) ? _c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "remark-text"
  }, [_vm._v("您的意见")]), _vm._v(" "), (!_vm.disabled) ? _c('div', {
    staticClass: "textarea"
  }, [_vm._v(_vm._s(_vm.remark))]) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "请输入您宝贵的意见或建议，以便于帮助我们改善服务 质量",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.status !== 40) ? _c('div', {
    staticClass: "submit"
  }, [_c('span', {
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("提交评价")])]) : _vm._e(), _vm._v(" "), (_vm.hintBox.state) ? _c('xk-hint-Box', {
    attrs: {
      "time": 1500,
      "state": _vm.hintBox.showState,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611c81ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/daijia/affirm.vue
// module id = 537
// module chunks = 0